class Logger {
    debugEnabled = false;

    debug (message: any, ...optionalParams: any[]) {
      if (this.debugEnabled) {
        console.debug(message, ...optionalParams);
      }
    }

    error (message: any, ...optionalParams: any[]) {
      if (this.debugEnabled) {
        console.error(message, ...optionalParams);
      }
    }

    enableDebug () {
      this.debugEnabled = true;
      this.debug('Enabled Logger');
    }
}

window.Logger = new Logger();

window.Logger.enableDebug();

export default window.Logger;
